import { Cart } from '@diamond/shared/types';

export const groupCartByDivision = (items: Cart[]) => {
  return items.reduce<Record<string, Cart[]>>((acc, item) => {
    const key = item.product.division;
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);
    return acc;
  }, {});
};
